import { Pipe, PipeTransform } from '@angular/core';
import { ValidationError } from '../models/validation/validation-error';
import { ReferenceDataService } from '../services/reference-data.service';

@Pipe({
  name: 'localizeErrorMessage'
})
export class LocalizeErrorMessagePipe implements PipeTransform {
  constructor(private readonly referenceDataService: ReferenceDataService) {}

  transform(name: string, code: string, args?: Array<string>, key?: string): string {
    args = args === undefined ? [] : args;

    return this.referenceDataService.getLocalizeErrorMessage(new ValidationError(key, name, code, args));
  }
}
